import React from 'react';
import './InactiveCustomerAlert.css';

interface InactiveCustomerAlertProps {
  customerName?: string | null;
  cardCode?: string | null;
  reason: 'inactive' | 'frozen';
  onClose?: () => void;
}

const InactiveCustomerAlert: React.FC<InactiveCustomerAlertProps> = ({
  customerName,
  cardCode,
  reason,
  onClose,
}) => {
  const getTitle = () => {
    return reason === 'frozen' ? 'Cliente Congelado' : 'Cliente Inactivo';
  };

  const getDescription = () => {
    if (reason === 'frozen') {
      return 'Su cuenta se encuentra congelada en nuestro sistema.';
    }
    return 'Su cuenta se encuentra inactiva en nuestro sistema.';
  };

  return (
    <div className="inactive-customer-alert">
      <div className="alert-content">
        <div className="alert-icon">
          <span className="warning-icon">⚠️</span>
        </div>

        <div className="alert-body">
          <h3 className="alert-title">{getTitle()}</h3>

          {customerName && (
            <p className="customer-info">
              <strong>Cliente:</strong> {customerName}
              {cardCode && <span className="card-code"> (Código: {cardCode})</span>}
            </p>
          )}

          <p className="alert-description">{getDescription()}</p>

          <div className="alert-actions-info">
            <p className="action-required">
              <strong>¿Qué debe hacer?</strong>
            </p>
            <p className="action-description">
              Por favor acérquese a la <strong>sede más cercana</strong> para actualizar su información
              y {reason === 'frozen' ? 'descongelar' : 'reactivar'} su cuenta.
            </p>
            <p className="contact-info">
              También puede comunicarse con nosotros a través del botón de WhatsApp en la esquina inferior derecha.
            </p>
          </div>

          <div className="alert-notice">
            <span className="notice-icon">ℹ️</span>
            <span className="notice-text">
              No podrá realizar pagos hasta que su cuenta esté activa.
            </span>
          </div>
        </div>

        {onClose && (
          <button className="alert-close-btn" onClick={onClose} aria-label="Cerrar alerta">
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default InactiveCustomerAlert;
